import React    from 'react'
//
import Page     from 'components/Page'
import Head     from 'components/Head'

export default () => (
	<Page>
		<Head
            title="404 - Sorry, we’ve searched the Ward and nothing turned up!"
            description="404 - Not found. Sorry, we’ve searched the Ward and nothing turned up!"
        />
        <section>
            <div className="section__block" data-lateral=" ">
        		<div className="container">
        			<h1>404 - Sorry, we’ve searched the Ward and nothing turned up!</h1>
        		</div>
            </div>
        </section>
  	</Page>
)



// WEBPACK FOOTER //
// /opt/build/repo/src/pages/404.js